import { createFetchTypes } from '../../utils/createFetchTypes';

export const ADD_NEW_FORM_ENTRY = 'ADD_NEW_FORM_ENTRY';
export const UPDATE_FORM_ENTRY = 'UPDATE_FORM_ENTRY';
export const REMOVE_FORM_ENTRY = 'REMOVE_FORM_ENTRY';
export const ADD_NEW_FORM_STRUCTURE = 'ADD_NEW_FORM_STRUCTURE';
export const DELETE_FORM = 'DELETE_FORM';
export const GET_SUBJECTS = 'GET_SUBJECTS';
export const GET_FORM_REPORT = 'GET_FORM_REPORT';
export const DELETE_FORM_REPORT = 'DELETE_FORM_REPORT';
export const EDIT_FORM = 'EDIT_FORM';
export const SORT_FORMS = 'SORT_FORMS';
export const REORDER_FORM = 'REORDER_FORM';
export const REORDER_FORM_FAILURE = 'REORDER_FORM_FAILURE';
export const UPLOAD_MEDIA_SUCCESS = 'UPLOAD_MEDIA_SUCCESS';
export const UPLOAD_MEDIA_ERROR = 'UPLOAD_MEDIA_ERROR';
export const UPLOAD_MEDIA_REQUEST = 'UPLOAD_MEDIA_REQUEST';
export const IS_DELETING_FORM_ENTRY = 'IS_DELETING_FORM_ENTRY';
export const PENDING__MORE_ENTRIES = 'PENDING__MORE_ENTRIES';
export const CHANGE_VISIBLE_OF_FIELDS = 'CHANGE_VISIBLE_OF_FIELDS';
export const DELETE_FORM_EXPORT = 'DELETE_FORM_EXPORT';

// ****************** createFetchType
export const GET_FORM_STRUCTURE = createFetchTypes('GET_FORM_STRUCTURE');
export const GET_FORM_ENTRIES = createFetchTypes('GET_FORM_ENTRIES');
export const GET_ALL_FORMS = createFetchTypes('GET_ALL_FORMS');
export const SET_ENTRIES_OF_A_FORM = createFetchTypes('SET_ENTRIES_OF_A_FORM');
